import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {半角カナ禁止} from '@/type/validation/validator';
import {優先卸検索依頼型} from '@/type/wholesale/primary/wholesale';

export default class 優先卸検索条件チェッカー {
  単項目チェック結果: Error[];

  constructor(target: 優先卸検索依頼型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.map((value) => `${value.message}`);
  }
}

const 単項目チェックvalidators: Validator[] = [
  {
    name: '商品名カナ',
    constraints: [
      {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
    ],
  },
];
